export default __webpack_public_path__ + "static/media/TikTok_DownloadResult_Final.4e95dd70.PNG";